import { render } from "./SheetTrigger.vue?vue&type=template&id=025dde1f&ts=true"
import script from "./SheetTrigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetTrigger.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sheet/SheetTrigger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "025dde1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('025dde1f', __exports__)) {
    api.reload('025dde1f', __exports__)
  }
  
  module.hot.accept("./SheetTrigger.vue?vue&type=template&id=025dde1f&ts=true", () => {
    api.rerender('025dde1f', render)
  })

}


export default __exports__